export const formatUnitNum = (unitId: string): string => parseInt(unitId?.split("-")[unitId?.split("-").length - 1]).toString()